import React, { useEffect } from "react";
import Header from "./Header/Header";
import "./AnalyticsScreen.scss";
import BasicReports from "./BasicReports/BasicReports";
import { fetchBasicAnalyticsRequest } from "../../../redux/exam_analytics/analyticsSlice";
import useAppHooks from "../../../shared/hooks/useAppHooks";

const AnalyticsScreen = () => {
  const { dispatch, selector } = useAppHooks();

  useEffect(() => {
    dispatch(fetchBasicAnalyticsRequest());
  }, []);

  const { basicAnalytics } = selector((s) => s.analyticsSlice);

  const apiData = basicAnalytics?.data || null;

  return (
    <div className="analytics-wrapper">
      <Header paperName={apiData?.paper_name} />
      <BasicReports basicAnalytics={apiData} />
    </div>
  );
};

export default AnalyticsScreen;
